// Angular
import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";

// Ant
import { NzModalComponent, NzModalContentDirective, NzModalModule } from "ng-zorro-antd/modal";
import { NzOptionComponent, NzSelectComponent } from "ng-zorro-antd/select";
import { NzButtonComponent } from "ng-zorro-antd/button";
import { NzIconDirective } from "ng-zorro-antd/icon";

// Models
import { NavigationLayoutItemsList } from "#models/navigation";

// Components
import { NavigationBaseComponent } from "#components/navigation-base/navigation-base.component";

// Other
import { HotkeysService } from "@ngneat/hotkeys";
import { TranslatePipe } from "#pipes/i18n/translate.pipe";

@Component({
    selector: "app-goto",
    imports: [
        NzModalModule,
        NzButtonComponent,
        NzModalComponent,
        NzModalContentDirective,
        NzSelectComponent,
        FormsModule,
        NzOptionComponent,
        TranslatePipe,
        NzIconDirective,
    ],
    templateUrl: "./goto.component.html",
    styleUrl: "./goto.component.scss",
})
export class GotoComponent extends NavigationBaseComponent implements OnInit {
    @ViewChild(NzSelectComponent) nzSelect!: NzSelectComponent;

    private hotKeys = inject(HotkeysService);

    selectedValue = "";
    isVisible = false;

    ngOnInit(): void {
        this.hotKeys
            .addShortcut({ keys: "shift.space", preventDefault: true })
            .subscribe(() => this.toggleModal());
    }

    toggleModal() {
        this.isVisible = !this.isVisible;
        this.selectedValue = this.router.url.includes("type_id")
            ? this.router.url
            : `${this.router.url.split("?")[0]}`;

        setTimeout(() => {
            if (this.nzSelect) {
                this.nzSelect.focus();
                const renderedOptions = this.nzSelect.listOfNzOptionComponent.map(
                    (opt) => opt.nzValue
                );

                // Find the first option that starts with 'jack'
                const match = renderedOptions.find(
                    (opt) => typeof opt === "string" && opt.startsWith(this.selectedValue)
                );

                if (match) {
                    this.selectedValue = match; // Sync with the model
                }
            }
        }, 10);
    }

    async onChange(link: string) {
        this.toggleModal();
        let redirect = true;

        this.list.forEach((item) => {
            if (item.link === link && item.callback) {
                redirect = false;

                return item.callback();
            }
        });

        if (redirect) {
            await this.router.navigateByUrl(link);
        }
    }

    getLink(item: NavigationLayoutItemsList["children"][0]) {
        const queryParams = this.getQueryParamsForLink(item);
        const urlTree = this.router.createUrlTree([item.link], { queryParams });

        return this.router.serializeUrl(urlTree);
    }
}
